import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import type { RootState } from '../store';
import { membershipIdFromJwt } from '../store/authSlice';

/** Membership id for the currently selected org (not user id — user can span orgs). */
export function useCurrentMembershipId(): string | null {
  const stored = useSelector((s: RootState) => s.auth.membershipId);
  const accessToken = useSelector((s: RootState) => s.auth.accessToken);
  const org = useSelector((s: RootState) => s.auth.org);
  const orgs = useSelector((s: RootState) => s.auth.orgs);

  return useMemo(() => {
    if (stored) return String(stored);

    const fromJwt = membershipIdFromJwt(accessToken);
    if (fromJwt) return fromJwt;

    const orgId = String(org?.id ?? org?.orgId ?? '');
    if (!orgId) return null;
    const match = orgs.find((o) => String(o.orgId) === orgId);
    return match?.membershipId != null ? String(match.membershipId) : null;
  }, [stored, accessToken, org, orgs]);
}
